import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { languages } from '../../constants/languages';

const DeletePlayersDialog = ({ open, handleClose, handleConfirm, selectedTeams }) => {
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="delete-players-dialog-title"
    >
      <DialogTitle id="delete-players-dialog-title">
        {languages.teams.deletePlayersConfirmTitle}
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          {languages.teams.deletePlayersConfirmMessage.replace(
            '{count}',
            selectedTeams.length
          )}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          {languages.general.cancel}
        </Button>
        <Button onClick={handleConfirm} color="secondary" autoFocus>
          {languages.general.continue}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeletePlayersDialog; 